import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sidebar-container"
}
const _hoisted_2 = ["src"]

import { t } from '@/plugins/i18n'
import { useStore } from 'vuex'
import SidebarItem from './SidebarItem.vue'
import sidebar from '@/assets/css/theme/sidebar.scss'
import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { isShowStockJpBtn, isJpPurchase } from '@/store'
import { cloneDeep } from 'lodash'
import { JP_GOODS_PURCHASE, JP_GOODS_PURCHASE_HAS_TIKTOK, STOCK_JP_SHIPPING } from '@/router/authCode'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

_useCssVars(_ctx => ({
  "c7bddacc": (_unref(sidebarWidth))
}))

const collapse = ref(false)
const sidebarWidth = computed(() => {
  if (!collapse.value) {
    return '220px'
  }
  return 'auto'
})
const store = useStore()
const route = useRoute()
const userRoutes = ref(store.getters['route/userRoutes'].filter(v => v.name !== 'inshipping_d2c'))
const filterTouter = (routes: any, showAuth: number[], hiddenAuth: number[]) => {
  const newRoute = cloneDeep(routes)
  const setRt = (routes: any) => {
    return routes.filter((t: any) => {
      if (t.children) {
        t.children = setRt(t.children)
      }
      // 是否隐藏判断
      if (t.meta?.hiddenAuth && hiddenAuth.some(a => t.meta?.hiddenAuth.includes(a))) {
        return false
      }
      // 是否显示判断
      if (t.meta?.showAuth && !showAuth.some(a => t.meta?.showAuth.includes(a))) {
        return false
      }
      return true
    })
  }
  return setRt(newRoute)
}
onMounted(async () => {
  const routerList = store.getters['route/userRoutes']
  const showAuth: number[] = []
  const hiddenAuth: number[] = []
  // 先隐藏
  userRoutes.value = filterTouter(routerList, showAuth, hiddenAuth)
  const show = await isShowStockJpBtn()
  if (show) {
    showAuth.push(STOCK_JP_SHIPPING)
  }
  await store.dispatch('status/setJpPurchase', {}, { root: true })
  if (isJpPurchase()) {
    showAuth.push(JP_GOODS_PURCHASE)
  }
  if (store.getters.isJpPurchase) {
    showAuth.push(JP_GOODS_PURCHASE_HAS_TIKTOK)
  }
  userRoutes.value = filterTouter(routerList, showAuth, hiddenAuth)
  console.log('routerList', showAuth, hiddenAuth, userRoutes.value)
})

const activeMenu = computed(() => {
  const { name } = route as any
  const activeMenu = name ? name.split('_')[0] : ''
  return activeMenu
})
const curShop = computed(() => store.state.route.curShop)
const collapseClick = () => {
  collapse.value = !collapse.value
}

return (_ctx: any,_cache: any) => {
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_unref(curShop))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_scrollbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_menu, {
              "popper-class": "menu-popper",
              "default-active": _unref(activeMenu),
              collapse: collapse.value,
              "background-color": _unref(sidebar).fcolor,
              "collapse-transition": false,
              key: _unref(store).getters.renderSidebar
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userRoutes.value, (route) => {
                  return (_openBlock(), _createBlock(SidebarItem, {
                    collapse: collapse.value,
                    key: route.name,
                    item: route,
                    "base-path": route.path
                  }, null, 8, ["collapse", "item", "base-path"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["default-active", "collapse", "background-color"])
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          style: _normalizeStyle([{"height":"50px","position":"absolute","bottom":"20px","display":"flex","justify-content":"center","align-items":"center","cursor":"pointer"}, collapse.value ? 'width: 56px;' : 'width: 220px;'])
        }, [
          _createElementVNode("img", {
            onClick: collapseClick,
            src: collapse.value ? 'https://static-s.theckb.com/BusinessMarket/Client/Menu-unfold.svg' : 'https://static-s.theckb.com/BusinessMarket/Client/Menu-fold.svg'
          }, null, 8, _hoisted_2)
        ], 4)
      ]))
    : _createCommentVNode("", true)
}
}

})